import angular from 'angular';

import header from './header/header.component';
import nav from './nav/nav.component';
import footer from './footer/footer.component';

import stepDiagram from './step-diagram/step-diagram.component';
import stepDiagram2 from './step-diagram-2/step-diagram-2.component';
import scqDiagram from './scq-diagram/scq-diagram.component';
import scqDiagramDND from './scq-diagram-dnd/scq-diagram.component';
import scqDiagramDNDFramework from './scq-diagram-dnd-framework/scq-diagram-dnd-framework.component';
import highlightDiagram from './highlight-diagram/highlight-diagram.component';
import checkboxDiagram from './checkbox-diagram/checkbox-diagram.component';

import pyramidBuilderComponent from './pyramid-builder/pyramid-builder.component';
import magnifierComponent from './magnifier/magnifier.component'
import arrowTooltipComponent from './arrow-tooltip/arrow-tooltip.component';
import fullWordingIntroductionPaper from './fullWordingIntroductionPaper/fullWordingIntroductionPaper.component';

// Tree diagram
import treeDiagram from './tree-diagram/tree-renderer.directive';
import buttonDraggable from './tree-diagram/button-draggable.directive';
import button from './tree-diagram/button.directive';
import numberMinMax from './tree-diagram/number-min-max.directive';
import { treeDiagramRendererFactory, treeDiagramFactory } from './tree-diagram/factory';
//end

//Unit 1 diagrams
import diagram11A1Ex1 from './diagrams/1/1a/diagram1/diagram1.component';
import diagram11A1Ex2 from './diagrams/1/1a/diagram2/diagram2.component';
import diagram11A1Ex3 from './diagrams/1/1a/diagram3/diagram3.component';
import diagram11A1Ex4 from './diagrams/1/1a/diagram4/diagram4.component';

import diagram11B1Ex1 from './diagrams/1/1b/diagram1/diagram1.component';
import diagram11B1Ex2 from './diagrams/1/1b/diagram2/diagram2.component';
import diagram11B1Ex3 from './diagrams/1/1b/diagram3/diagram3.component';
import diagram11B1Ex4 from './diagrams/1/1b/diagram4/diagram4.component';

import diagram11C1Ex1 from './diagrams/1/1c/diagram1/diagram1.component';
import diagram11C1Ex2 from './diagrams/1/1c/diagram2/diagram2.component';
import diagram11C1Ex3 from './diagrams/1/1c/diagram3/diagram3.component';
import diagram11C1Ex4 from './diagrams/1/1c/diagram4/diagram4.component';

import diagram11D1Ex1 from './diagrams/1/1d/diagram1/diagram1.component';
import diagram11D1Ex2 from './diagrams/1/1d/diagram2/diagram2.component';
import diagram11D1Ex3 from './diagrams/1/1d/diagram3/diagram3.component';
import diagram11D1Ex4 from './diagrams/1/1d/diagram4/diagram4.component';
import diagram11D1Ex5 from './diagrams/1/1d/diagram5/diagram5.component';

//Unit 2 diagrams
import diagram22B1Ex1 from './diagrams/2/2b/diagram1/diagram1.component';
import diagram22B1Ex2 from './diagrams/2/2b/diagram2/diagram2.component';
import diagram22B1Ex3 from './diagrams/2/2b/diagram3/diagram3.component';
import diagram22B1Ex4 from './diagrams/2/2b/diagram4/diagram4.component';
import diagram22B1Ex5 from './diagrams/2/2b/diagram5/diagram5.component';
import diagram22B1Ex6 from './diagrams/2/2b/diagram6/diagram6.component';
import diagram22B1Ex7 from './diagrams/2/2b/diagram7/diagram7.component';
import diagram22B1Ex72 from './diagrams/2/2b/diagram8/diagram8.component';
import diagram22B1Ex8 from './diagrams/2/2b/diagram9/diagram9.component';
import diagram22B1Ex9 from './diagrams/2/2b/diagram10/diagram10.component';

//Unit 3 diagrams
import diagram33A1Ex1 from './diagrams/3/3a1/diagram1/diagram1.component';
import diagram33A1Ex2 from './diagrams/3/3a1/diagram2/diagram2.component';
import diagram33A1Ex3 from './diagrams/3/3a1/diagram3/diagram3.component';
import diagram33A1Ex4 from './diagrams/3/3a1/diagram4/diagram4.component';
import diagram33A1Ex5 from './diagrams/3/3a1/diagram5/diagram5.component';
import diagram33A1Ex6 from './diagrams/3/3a1/diagram6/diagram6.component';
import diagram33A1Ex7 from './diagrams/3/3a1/diagram7/diagram7.component';
import diagram33A1Ex8 from './diagrams/3/3a1/diagram8/diagram8.component';
import diagram33A1Ex9 from './diagrams/3/3a1/diagram9/diagram9.component';
import diagram33A1Ex10 from './diagrams/3/3a1/diagram10/diagram10.component';
import diagram33A1Ex11 from './diagrams/3/3a1/diagram11/diagram11.component';
import diagram33A1Ex12 from './diagrams/3/3a1/diagram12/diagram12.component';

import diagram33A2Ex1 from './diagrams/3/3a2/diagram1/diagram1.component';
import diagram33A2Ex2 from './diagrams/3/3a2/diagram2/diagram2.component';
import diagram33A2Ex3 from './diagrams/3/3a2/diagram3/diagram3.component';
import diagram33A2Ex4 from './diagrams/3/3a2/diagram4/diagram4.component';
import diagram33A2Ex5 from './diagrams/3/3a2/diagram5/diagram5.component';

import diagram33A3Ex1 from './diagrams/3/3a3/diagram1/diagram1.component';
import diagram33A3Ex2 from './diagrams/3/3a3/diagram2/diagram2.component';
import diagram33A3Ex3 from './diagrams/3/3a3/diagram3/diagram3.component';
import diagram33A3Ex4 from './diagrams/3/3a3/diagram4/diagram4.component';
import diagram33A3Ex5 from './diagrams/3/3a3/diagram5/diagram5.component';
import diagram33A3Ex6 from './diagrams/3/3a3/diagram6/diagram6.component';

import diagram33B1Ex1 from './diagrams/3/3b1/diagram1/diagram1.component';
import diagram33B1Ex2 from './diagrams/3/3b1/diagram2/diagram2.component';
import diagram33B1Ex3 from './diagrams/3/3b1/diagram3/diagram3.component';
import diagram33B1Ex4 from './diagrams/3/3b1/diagram4/diagram4.component';
import diagram33B1Ex5 from './diagrams/3/3b1/diagram5/diagram5.component';
import diagram33B1Ex6 from './diagrams/3/3b1/diagram6/diagram6.component';
import diagram33B1Ex7 from './diagrams/3/3b1/diagram7/diagram7.component';

import diagram33B2Ex1 from './diagrams/3/3b2/diagram1/diagram1.component';
import diagram33B2Ex2 from './diagrams/3/3b2/diagram2/diagram2.component';
import diagram33B2Ex3 from './diagrams/3/3b2/diagram3/diagram3.component';
import diagram33B2Ex4 from './diagrams/3/3b2/diagram4/diagram4.component';
import diagram33B2Ex5 from './diagrams/3/3b2/diagram5/diagram5.component';

import diagram33B3Ex1 from './diagrams/3/3b3/diagram1/diagram1.component';
import diagram33B3Ex2 from './diagrams/3/3b3/diagram2/diagram2.component';
import diagram33B3Ex3 from './diagrams/3/3b3/diagram3/diagram3.component';
import diagram33B3Ex4 from './diagrams/3/3b3/diagram4/diagram4.component';
import diagram33B3Ex5 from './diagrams/3/3b3/diagram5/diagram5.component';
import diagram33B3Ex6 from './diagrams/3/3b3/diagram6/diagram6.component';
import diagram33B3Ex7 from './diagrams/3/3b3/diagram7/diagram7.component';

import diagram33B4Ex1 from './diagrams/3/3b4/diagram1/diagram1.component';
import diagram33B4Ex2 from './diagrams/3/3b4/diagram2/diagram2.component';
import diagram33B4Ex3 from './diagrams/3/3b4/diagram3/diagram3.component';
import diagram33B4Ex4 from './diagrams/3/3b4/diagram4/diagram4.component';
import diagram33B4Ex5 from './diagrams/3/3b4/diagram5/diagram5.component';

//Unit 4 diagrams
import diagram44aEx1 from './diagrams/4/4a/diagram1/diagram1.component';
import diagram44aEx2 from './diagrams/4/4a/diagram2/diagram2.component';
import diagram44aEx3 from './diagrams/4/4a/diagram3/diagram3.component';
import diagram44aEx4 from './diagrams/4/4a/diagram4/diagram4.component';
import diagram44aEx5 from './diagrams/4/4a/diagram5/diagram5.component';

import diagram44B1Ex1 from './diagrams/4/4b1/diagram1/diagram1.component';
import diagram44B1Ex2 from './diagrams/4/4b1/diagram2/diagram2.component';

import diagram44B2Ex1 from './diagrams/4/4b2/diagram1/diagram1.component';
import diagram44B2Ex2 from './diagrams/4/4b2/diagram2/diagram2.component';
import diagram44B2Ex3 from './diagrams/4/4b2/diagram3/diagram3.component';
import diagram44B2Ex4 from './diagrams/4/4b2/diagram4/diagram4.component';
import diagram44B2Ex5 from './diagrams/4/4b2/diagram5/diagram5.component';
import diagram44B2Ex6 from './diagrams/4/4b2/diagram6/diagram6.component';

import diagram44C1Ex1 from './diagrams/4/4c/diagram1/diagram1.component';
import diagram44C1Ex2 from './diagrams/4/4c/diagram2/diagram2.component';
import diagram44C1Ex3 from './diagrams/4/4c/diagram3/diagram3.component';
import diagram44C1Ex4 from './diagrams/4/4c/diagram4/diagram4.component';

//Unit 5 diagrams
import diagram55A1Ex1 from './diagrams/5/5a/diagram1/diagram1.component';
import diagram55A1Ex2 from './diagrams/5/5a/diagram2/diagram2.component';
import diagram55A1Ex3 from './diagrams/5/5a/diagram3/diagram3.component';

import diagram55B1Ex1 from './diagrams/5/5b/diagram1/diagram1.component';
import diagram55B1Ex2 from './diagrams/5/5b/diagram2/diagram2.component';
import diagram55B1Ex3 from './diagrams/5/5b/diagram3/diagram3.component';
import diagram55B1Ex4 from './diagrams/5/5b/diagram4/diagram4.component';
import diagram55B1Ex5 from './diagrams/5/5b/diagram5/diagram5.component';
import diagram55B1Ex6 from './diagrams/5/5b/diagram6/diagram6.component';

import diagram55C1Ex1 from './diagrams/5/5c/diagram1/diagram1.component';
import diagram55C1Ex2 from './diagrams/5/5c/diagram2/diagram2.component';
import diagram55C1Ex3 from './diagrams/5/5c/diagram3/diagram3.component';
import diagram55C1Ex4 from './diagrams/5/5c/diagram4/diagram4.component';
import diagram55C1Ex5 from './diagrams/5/5c/diagram5/diagram5.component';
import diagram55C1Ex6 from './diagrams/5/5c/diagram6/diagram6.component';
import diagram55C1Ex7 from './diagrams/5/5c/diagram7/diagram7.component';
import diagram55C1Ex8 from './diagrams/5/5c/diagram8/diagram8.component';

import diagram55D1Ex1 from './diagrams/5/5d/diagram1/diagram1.component';
import diagram55D1Ex2 from './diagrams/5/5d/diagram2/diagram2.component';
import diagram55D1Ex3 from './diagrams/5/5d/diagram3/diagram3.component';
import diagram55D1Ex4 from './diagrams/5/5d/diagram4/diagram4.component';
import diagram55D1Ex5 from './diagrams/5/5d/diagram5/diagram5.component';
import diagram55D1Ex6 from './diagrams/5/5d/diagram6/diagram6.component';

//Carousel
import carouselSlider from './carousel-slider/carousel-slider.component'

//Popups
import introductionPopup from './popups/dashboard/introduction-popup/introduction-popup.component'
import testDrivePopup from './popups/dashboard/test-drive-popup/test-drive-popup.component'

const components = angular.module('minto.components', []);


// Tree diagram
components.factory('treeDiagramRendererFactory', treeDiagramRendererFactory);
components.factory('treeDiagramFactory', treeDiagramFactory);
components.directive('treeDiagram', treeDiagram);
components.directive('buttonDraggable', buttonDraggable);
components.directive('button', button);
components.directive('numberMinMax', numberMinMax);
// end

components.component('moHeader', header);
components.component('moNav', nav);
components.component('moFooter', footer);

components.component('stepDiagram', stepDiagram);
components.component('stepDiagram2', stepDiagram2);
components.component('scqDiagram', scqDiagram);
components.component('scqDiagramDnd', scqDiagramDND);
components.component('scqDiagramDndFramework', scqDiagramDNDFramework);
components.component('highlightDiagram', highlightDiagram);
components.component('checkboxDiagram', checkboxDiagram);
components.component('pyramidBuilder', pyramidBuilderComponent);
components.component('magnifierComponent', magnifierComponent);
components.component('arrowTooltipComponent', arrowTooltipComponent);
components.component('fullWordingIntroductionPaper', fullWordingIntroductionPaper);

//
// Popups
components.component('introductionPopup', introductionPopup);
components.component('testDrivePopup', testDrivePopup);

//
// 1A
components.component('modiagram11A1Ex1', diagram11A1Ex1);
components.component('modiagram11A1Ex2', diagram11A1Ex2);
components.component('modiagram11A1Ex3', diagram11A1Ex3);
components.component('modiagram11A1Ex4', diagram11A1Ex4);

//
// 1B
components.component('modiagram11B1Ex1', diagram11B1Ex1);
components.component('modiagram11B1Ex2', diagram11B1Ex2);
components.component('modiagram11B1Ex3', diagram11B1Ex3);
components.component('modiagram11B1Ex4', diagram11B1Ex4);

//
// 1C
components.component('modiagram11C1Ex1', diagram11C1Ex1);
components.component('modiagram11C1Ex2', diagram11C1Ex2);
components.component('modiagram11C1Ex3', diagram11C1Ex3);
components.component('modiagram11C1Ex4', diagram11C1Ex4);

//
// 1D
components.component('modiagram11D1Ex1', diagram11D1Ex1);
components.component('modiagram11D1Ex2', diagram11D1Ex2);
components.component('modiagram11D1Ex3', diagram11D1Ex3);
components.component('modiagram11D1Ex4', diagram11D1Ex4);
components.component('modiagram11D1Ex5', diagram11D1Ex5);

//
// 2B
components.component('modiagram22B1Ex1', diagram22B1Ex1);
components.component('modiagram22B1Ex2', diagram22B1Ex2);
components.component('modiagram22B1Ex3', diagram22B1Ex3);
components.component('modiagram22B1Ex4', diagram22B1Ex4);
components.component('modiagram22B1Ex5', diagram22B1Ex5);
components.component('modiagram22B1Ex6', diagram22B1Ex6);
components.component('modiagram22B1Ex7', diagram22B1Ex7);
components.component('modiagram22B1Ex72', diagram22B1Ex72);
components.component('modiagram22B1Ex8', diagram22B1Ex8);
components.component('modiagram22B1Ex9', diagram22B1Ex9);

//
// 3A1
components.component('modiagram33A1Ex1', diagram33A1Ex1);
components.component('modiagram33A1Ex2', diagram33A1Ex2);
components.component('modiagram33A1Ex3', diagram33A1Ex3);
components.component('modiagram33A1Ex4', diagram33A1Ex4);
components.component('modiagram33A1Ex5', diagram33A1Ex5);
components.component('modiagram33A1Ex6', diagram33A1Ex6);
components.component('modiagram33A1Ex7', diagram33A1Ex7);
components.component('modiagram33A1Ex8', diagram33A1Ex8);
components.component('modiagram33A1Ex9', diagram33A1Ex9);
components.component('modiagram33A1Ex10', diagram33A1Ex10);
components.component('modiagram33A1Ex11', diagram33A1Ex11);
components.component('modiagram33A1Ex12', diagram33A1Ex12);
// 3A2
components.component('modiagram33A2Ex1', diagram33A2Ex1);
components.component('modiagram33A2Ex2', diagram33A2Ex2);
components.component('modiagram33A2Ex3', diagram33A2Ex3);
components.component('modiagram33A2Ex4', diagram33A2Ex4);
components.component('modiagram33A2Ex5', diagram33A2Ex5);
// 3A3
components.component('modiagram33A3Ex1', diagram33A3Ex1);
components.component('modiagram33A3Ex2', diagram33A3Ex2);
components.component('modiagram33A3Ex3', diagram33A3Ex3);
components.component('modiagram33A3Ex4', diagram33A3Ex4);
components.component('modiagram33A3Ex5', diagram33A3Ex5);
components.component('modiagram33A3Ex6', diagram33A3Ex6);
// 3B1
components.component('modiagram33B1Ex1', diagram33B1Ex1);
components.component('modiagram33B1Ex2', diagram33B1Ex2);
components.component('modiagram33B1Ex3', diagram33B1Ex3);
components.component('modiagram33B1Ex4', diagram33B1Ex4);
components.component('modiagram33B1Ex5', diagram33B1Ex5);
components.component('modiagram33B1Ex6', diagram33B1Ex6);
components.component('modiagram33B1Ex7', diagram33B1Ex7);
// 3B2
components.component('modiagram33B2Ex1', diagram33B2Ex1);
components.component('modiagram33B2Ex2', diagram33B2Ex2);
components.component('modiagram33B2Ex3', diagram33B2Ex3);
components.component('modiagram33B2Ex4', diagram33B2Ex4);
components.component('modiagram33B2Ex5', diagram33B2Ex5);
// 3B3
components.component('modiagram33B3Ex1', diagram33B3Ex1);
components.component('modiagram33B3Ex2', diagram33B3Ex2);
components.component('modiagram33B3Ex3', diagram33B3Ex3);
components.component('modiagram33B3Ex4', diagram33B3Ex4);
components.component('modiagram33B3Ex5', diagram33B3Ex5);
components.component('modiagram33B3Ex6', diagram33B3Ex6);
components.component('modiagram33B3Ex7', diagram33B3Ex7);
// 3B4
components.component('modiagram33B4Ex1', diagram33B4Ex1);
components.component('modiagram33B4Ex2', diagram33B4Ex2);
components.component('modiagram33B4Ex3', diagram33B4Ex3);
components.component('modiagram33B4Ex4', diagram33B4Ex4);
components.component('modiagram33B4Ex5', diagram33B4Ex5);

//
// 4a
components.component('modiagram44aEx1', diagram44aEx1);
components.component('modiagram44aEx2', diagram44aEx2);
components.component('modiagram44aEx3', diagram44aEx3);
components.component('modiagram44aEx4', diagram44aEx4);
components.component('modiagram44aEx5', diagram44aEx5);

//
// 4B1
components.component('modiagram44B1Ex1', diagram44B1Ex1);
components.component('modiagram44B1Ex2', diagram44B1Ex2);
//
// 4B2
components.component('modiagram44B2Ex1', diagram44B2Ex1);
components.component('modiagram44B2Ex2', diagram44B2Ex2);
components.component('modiagram44B2Ex3', diagram44B2Ex3);
components.component('modiagram44B2Ex4', diagram44B2Ex4);
components.component('modiagram44B2Ex5', diagram44B2Ex5);
components.component('modiagram44B2Ex6', diagram44B2Ex6);
//
// 4C
components.component('modiagram44C1Ex1', diagram44C1Ex1);
components.component('modiagram44C1Ex2', diagram44C1Ex2);
components.component('modiagram44C1Ex3', diagram44C1Ex3);
components.component('modiagram44C1Ex4', diagram44C1Ex4);
//
// 5A
components.component('modiagram55A1Ex1', diagram55A1Ex1);
components.component('modiagram55A1Ex2', diagram55A1Ex2);
components.component('modiagram55A1Ex3', diagram55A1Ex3);
//
// 5B
components.component('modiagram55B1Ex1', diagram55B1Ex1);
components.component('modiagram55B1Ex2', diagram55B1Ex2);
components.component('modiagram55B1Ex3', diagram55B1Ex3);
components.component('modiagram55B1Ex4', diagram55B1Ex4);
components.component('modiagram55B1Ex5', diagram55B1Ex5);
components.component('modiagram55B1Ex6', diagram55B1Ex6);
//
// 5C
components.component('modiagram55C1Ex1', diagram55C1Ex1);
components.component('modiagram55C1Ex2', diagram55C1Ex2);
components.component('modiagram55C1Ex3', diagram55C1Ex3);
components.component('modiagram55C1Ex4', diagram55C1Ex4);
components.component('modiagram55C1Ex5', diagram55C1Ex5);
components.component('modiagram55C1Ex6', diagram55C1Ex6);
components.component('modiagram55C1Ex7', diagram55C1Ex7);
components.component('modiagram55C1Ex8', diagram55C1Ex8);
//
// 5D
components.component('modiagram55D1Ex1', diagram55D1Ex1);
components.component('modiagram55D1Ex2', diagram55D1Ex2);
components.component('modiagram55D1Ex3', diagram55D1Ex3);
components.component('modiagram55D1Ex4', diagram55D1Ex4);
components.component('modiagram55D1Ex5', diagram55D1Ex5);
components.component('modiagram55D1Ex6', diagram55D1Ex6);
//
// Carousel slider
components.component('carouselSlider', carouselSlider);

export default components;



// WEBPACK FOOTER //
// ./client/app/components/components.module.js